module.exports = __webpack_public_path__ + "static/media/students2.dd7576d4.svg";